const Revert10 = () => (
  <>
    <path
      fill="currentColor"
      d="M12 21a7.8 7.8 0 0 1-3.118-.626 8.1 8.1 0 0 1-2.542-1.713 8.1 8.1 0 0 1-1.714-2.543A7.8 7.8 0 0 1 4 13q0-.213.143-.357A.48.48 0 0 1 4.5 12.5q.213 0 .357.143A.48.48 0 0 1 5 13q0 2.925 2.037 4.962T12 20t4.962-2.038T19 13t-2.038-4.962T12 6h-.38l1.272 1.273a.488.488 0 0 1 0 .708.5.5 0 0 1-.356.168.49.49 0 0 1-.357-.162l-1.921-1.94a.78.78 0 0 1-.243-.566q0-.324.243-.565l1.96-1.941a.484.484 0 0 1 .713.006q.159.165.162.354a.49.49 0 0 1-.162.354L11.619 5H12q1.663 0 3.118.626T17.66 7.34a8.1 8.1 0 0 1 1.714 2.542Q20 11.337 20 13a7.8 7.8 0 0 1-.626 3.118 8.1 8.1 0 0 1-1.713 2.543 8.1 8.1 0 0 1-2.543 1.713Q13.663 21 12 21"
    />
    <path
      fill="currentColor"
      d="M8.48 11.192h.943v4.058a.43.43 0 0 0 .443.442.43.43 0 0 0 .442-.442v-4.5a.43.43 0 0 0-.442-.442H8.48a.43.43 0 0 0-.442.443.43.43 0 0 0 .442.441"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.692 15.692a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713v-3.384q0-.425.288-.713a.97.97 0 0 1 .712-.287h1.77q.424 0 .712.287.288.288.287.713v3.384q0 .426-.287.713a.97.97 0 0 1-.713.287zm1.654-.884h-1.538q-.116 0-.174-.058t-.057-.173v-3.154q0-.115.057-.173.059-.058.174-.058h1.538q.116 0 .173.058.058.058.058.173v3.154q0 .115-.058.173-.057.058-.173.058"
      clipRule="evenodd"
    />
  </>
)
export default Revert10
